import script from "./TheSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSideBar.vue?vue&type=script&setup=true&lang=js"

import "./TheSideBar.vue?vue&type=style&index=0&id=0344d66c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0344d66c"]])

export default __exports__